var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("swb-query-sort-area", {
        ref: "query_model_ctrl",
        staticClass: "mt10 mb10",
        attrs: {
          name: "query-sort-block",
          confKey: _vm.confKey,
          queryOnLoad: _vm.queryOnLoad,
          configAuto: _vm.configAuto,
          custConfEnabled: _vm.custConfEnabled,
          queryKey: _vm.queryKey,
          queryHandler: _vm.queryHandler
        }
      }),
      _vm._v(" "),
      _vm.bizAreaName != null
        ? _c("div", { attrs: { name: "bizAreaName" } }, [
            _c("span", [_vm._v("经营区域名称：" + _vm._s(_vm.bizAreaName))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("swb-result-table", {
        ref: "result_table",
        attrs: {
          name: "result_table",
          confKey: _vm.confKey,
          configAuto: _vm.configAuto,
          custConfEnabled: _vm.custConfEnabled,
          needPager: _vm.needPager,
          multiSelect: _vm.multiSelect,
          multiPageSelect: _vm.multiPageSelect,
          rowKeyPropName: _vm.rowKeyPropName,
          rowNoShow: _vm.rowNoShow,
          rowNoFixed: _vm.rowNoFixed,
          btnColName: _vm.btnColName,
          btnColTitle: _vm.btnColTitle,
          btnColWidth: _vm.btnColWidth,
          btnColFixed: _vm.btnColFixed,
          height: _vm.theTableHeight,
          rowDblClickHandler: _vm.rowDblClickHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37df15f7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37df15f7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/bizForm/BizFormListForSelect.vue
// module id = 2721
// module chunks = 0